export default __webpack_public_path__ + "static/edh-map-banner-482e178124ebb12c63c9e148d3147e54.png";